module.exports = __webpack_public_path__ + "static/media/chef.85d27f24.png";